import MultiTypeAttachments from "./MultiTypeAttachments";
export default MultiTypeAttachments;
